export function exitApp() {
	console.log("exitApp执行了");
	window.flutter_inappwebview
		.callHandler("pushNativeRoute", "loginPage")
		.then(function(token) {
			console.log("pushNativeRoute", token);
		});
}

export function redireUrl({ action, url }) {
	console.log("native redireUrl url: ", url);
	window.flutter_inappwebview
		.callHandler("pushNativeRoute", "loginPage", {
			action: action || "push",
			redirect: url || window.location.href
		})
		.then(function(token) {
			if (token) {
				//TODO:
				console.log("redireUrl success after", token);
			}
		});
}
// 租车通app统计
const onStatisticsEvent = (type, pageName) => {
	window.addEventListener("flutterInAppWebViewPlatformReady", function() {
		if (window.flutter_inappwebview) {
			window.flutter_inappwebview.callHandler("onStatisticsEvent", {
				type: type,
				pageName: pageName
			});
			// document.addEventListener("visibilitychange", function() {
			// 	var isHidden = document.hidden;
			// 	if (!isHidden) {
			// 		window.flutter_inappwebview.callHandler("onStatisticsEvent", {
			// 			type: type,
			// 			pageName: pageName
			// 		});
			// 	}
			// });
		}
	});
};
const importUrl = url => {
	let script = document.createElement("script");
	script.type = "text/javascript";
	script.async = true;
	script.src = url;
	document.head.appendChild(script);
};
export { onStatisticsEvent, importUrl };
